import React from 'react';
import { Switch, Route } from 'react-router-dom';
import ROUTES from '../constants';
import RouteExternal from '../RouteExternal';
import AuthenticatedRoute from '../../../pages/AuthenticatedRoute';
import Buying from '../../../pages/Buying';
import Pending from '../../../pages/Pending';
import Purchase from '../../../pages/Purchase';
import isOmpPlatform from '../../../_shared/utils/isOmpPlatform';

function RoutesBuying() {
  const buyingStates = [ROUTES.BUYING_ACTIVE, ROUTES.BUYING_UPCOMING];

  return (
    <Switch>
      <Route path={buyingStates}>
        <AuthenticatedRoute component={Buying} />
      </Route>
      <RouteExternal
        exact
        path={ROUTES.BUYING_CLOSING}
        link={ROUTES.TR4_BUY_CLOSING}
      />
      <Route key={ROUTES.BUYING_PENDING} path={[ROUTES.BUYING_PENDING]}>
        <AuthenticatedRoute component={Pending} />
      </Route>
      <RouteExternal exact path={ROUTES.BUYING_WON} link={ROUTES.TR4_BUY_WON} />
      <RouteExternal
        exact
        path={ROUTES.BUYING_ARRIVED}
        link={ROUTES.TR4_BUY_ARRIVED}
      />
      <RouteExternal
        exact
        path={ROUTES.BUYING_DELIVERED}
        link={ROUTES.TR4_BUY_DELIVERED}
      />
      {!isOmpPlatform() && (
        <Route key={ROUTES.BUYING_PURCHASE} path={[ROUTES.BUYING_PURCHASE]}>
          <AuthenticatedRoute component={Purchase} />
        </Route>
      )}
    </Switch>
  );
}

export default RoutesBuying;
